export default {"src":"/_next/static/media/link.43560491.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};